import ky from 'ky'
import Events from '@/utils/events'
import { API } from '@/config'

const HTTP = {
	token: localStorage.getItem('lapka:token'),

	setToken(token, refresh) {
		this.token = token
		localStorage.setItem('lapka:token', token)
		if (refresh) localStorage.setItem('lapka:refresh', refresh)
		Events.$emit('token-changed', token)
	},

	clearToken() {
		localStorage.removeItem('lapka:refresh')
		localStorage.removeItem('lapka:token')
		HTTP.token = null
	},

	async request(method, url, body, config, custom) {
		try {
			let res = await instance(url, {
				method: method,
				json: body,
				...config,
			})
			if (!res.ok) return res

			res.data = await res.json()
			res.custom = custom
			return res
		} catch (err) {
			console.log(err)
			return null
		}
	},

	get(url, body, config, custom) {
		return this.request('get', url, body, config, custom)
	},
	post(url, body, config, custom) {
		return this.request('post', url, body, config, custom)
	},
	put(url, body, config, custom) {
		return this.request('put', url, body, config, custom)
	},
	patch(url, body, config, custom) {
		return this.request('patch', url, body, config, custom)
	},
	delete(url, body, config, custom) {
		return this.request('delete', url, body, config, custom)
	},
	async upload(url, body) {
		let res = await instance.post(url, { body })
		if (!res.ok) return res

		res.data = await res.json()
		return res
	},
}

let isRefreshing = false
let refreshSubscribers = []

const refreshAccessToken = () => {
	return new Promise((resolve, reject) => {
		let refresh = localStorage.getItem('lapka:refresh')

		ky(API.AUTH.token, {
			method: 'post',
			prefixUrl: API.base,
			headers: {
				Token: HTTP.token,
			},
			json: { refresh },
		})
			.json()
			.then(res => {
				if (res && res.err && res.err === 'Invalid token') {
					HTTP.clearToken()
				}
				if (res.token) {
					resolve(res.token)
				} else {
					reject(res.err)
				}
			})
			.catch(err => reject(err))
	})
}

const subscribeTokenRefresh = cb => {
	refreshSubscribers.push(cb)
}

const onRrefreshed = token => {
	if (token) refreshSubscribers.map(cb => cb(token))
	refreshSubscribers = []
}

const hooks = {
	beforeRequest: [
		req => {
			req.headers.set('Token', HTTP.token)
		},
	],
	afterResponse: [
		async (request, options, response) => {
			let res
			if (response) res = await response.json()

			if (res && res.err === 'Token expired') {
				const originalRequest = request

				if (!isRefreshing) {
					isRefreshing = true
					refreshAccessToken()
						.then(newToken => {
							HTTP.setToken(newToken)
							isRefreshing = false
							onRrefreshed(newToken)
						})
						.catch(err => {
							isRefreshing = false
							onRrefreshed(null)
						})
				}

				return new Promise((resolve, reject) => {
					subscribeTokenRefresh(t => {
						if (t.err) return resolve({ err: t.err })

						// replace the expired token and retry
						originalRequest.headers.set('Token', HTTP.token) // potential error
						if (originalRequest.url.includes('refresh=true'))
							return resolve()
						resolve(ky(originalRequest)) // potential error 2
					})
				})
			}

			if (res && res.err === 'Invalid token') {
				HTTP.clearToken()
			} else {
				return res
			}
		},
	],
}

const instance = ky.create({
	prefixUrl: API.base,
	hooks: hooks,
	timeout: 60 * 1000,
})

export default HTTP
